import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import ProductBrand, { newProductBrand } from "../../models/product-brand";
import ProductBrandForm from "./ProductBrandForm";

interface ProductBrandUpdateModalProps {
  show: boolean;
  productBrand?: ProductBrand;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const ProductBrandUpdateModal: React.FC<ProductBrandUpdateModalProps> = ({
  show,
  productBrand,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors] = useState<Errors>({});
  const [initialProductBrand, setInitialProductBrand] = useState<ProductBrand>(
    productBrand ? productBrand : newProductBrand()
  );

  const modalTitle = productBrand
    ? `Editar Marca: ${productBrand.name}`
    : `Crear Marca nueva`;

  const onClose = () => {
    setInitialProductBrand(newProductBrand());
    onCancel();
  };

  useEffect(() => {
    setInitialProductBrand(productBrand ? productBrand : newProductBrand());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productBrand]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <ProductBrandForm
            initialProductBrand={initialProductBrand}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default ProductBrandUpdateModal;
